require('./pensionPlanPeriodicCancelDataTable.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { formatText } = require('core/i18n').i18n;
const IbanHelper = require('utilities/ibanHelper');
const { formatWithoutRound, getFormattedString } = require('utilities/currencyHelper');

// @components
const BrokerThreeContainerSummary = require('components/broker/brokerThreeContainerSummary/brokerThreeContainerSummary');

class PensionPlanPeriodicCancelDataTable extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { plan, cancelled, immBrokerPensionPlanPeriodicalContribution } = this.props;
        let data =  {
            leftContainer: [],
            middleContainer: [],
            rightContainer: []
        };
        const product = plan.getIn(['contrato','producto']);
        const contract = plan.getIn(['contrato','numerodecontrato']);
        const planContractNumber =  IbanHelper.calculateContract(`${product}${contract}`);
        const planImport = getFormattedString({
            amount: plan.getIn(['planAportacion','importe']),
            currency: plan.getIn(['planAportacion','divisa'])
        });
        const statusCancelled = formatText('pensionPlanContribution-statusCancelled');
        const statusActive = formatText('pensionPlanContribution-statusActive');
        const status = cancelled ? statusCancelled : statusActive;
        const notRevAnual = formatText('pensionPlanPeriodicalContribution-noRevalOptionLabel').toUpperCase();
        let revalAnual;
        if (immBrokerPensionPlanPeriodicalContribution.get('details').get('data').size > 0) {
            revalAnual = immBrokerPensionPlanPeriodicalContribution.get('details').get('data').get('datoRev')
        }
        const revalorizacionAnual = revalAnual ? `${formatWithoutRound(revalAnual, 2)}%` : notRevAnual;

        data.leftContainer.push([formatText('pensionPlanContribution-step2Item1'), planContractNumber]);
        data.leftContainer.push([formatText('pensionPlanContribution-step2Item2'), plan.get('nombreTitular')]);
        data.leftContainer.push([formatText('pensionPlanContribution-step2Item3'), plan.get('nombrePlan')]);

        data.middleContainer.push([formatText('pensionPlanContribution-step2Item4'), plan.getIn(['cuentaAsociada','codbban'])]);
        data.middleContainer.push([formatText('pensionPlanContribution-step2Item10'), status]);
        data.middleContainer.push([formatText('pensionPlanContribution-step2Item5'), planImport]);

        data.rightContainer.push([formatText('pensionPlanContribution-step2Item7'), plan.getIn(['planAportacion','periodicidad'])]);
        data.rightContainer.push([formatText('pensionPlanContribution-step2Item9'), revalorizacionAnual]);

        return (
            <section className="pension-plan-periodic-cancel-data-table__info-section row">
                <BrokerThreeContainerSummary
                    data={data}
                />
            </section>
        );
    }
}

PensionPlanPeriodicCancelDataTable.propTypes = {
    plan: PropTypes.object.isRequired,
    cancelled: PropTypes.bool,
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired
};

module.exports = PensionPlanPeriodicCancelDataTable;
